export const appRootId = 'root'
export const modalRootId = 'modalRoot'
export const breakPointKey = {
  small: 'small',
  medium: 'medium',
  large: 'large',
}
